import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from 'axios';
import cookies from 'vue-cookies';
import * as imageConversion from 'image-conversion';
export default {
  name: 'UploadForm',
  props: {
    selectedUrlForm: {
      type: String,
      default: 'url',
      required: false
    },
    customerCompress: {
      type: Boolean,
      default: true,
      required: false
    },
    compressQuality: {
      type: Number,
      default: 4,
      required: false
    },
    compressBar: {
      type: Number,
      default: 5,
      required: false
    },
    serverCompress: {
      type: Boolean,
      default: true,
      required: false
    },
    uploadChannel: {
      type: String,
      default: 'telegram',
      required: false
    },
    uploadNameType: {
      type: String,
      default: 'default',
      required: false
    },
    useCustomUrl: {
      type: String,
      default: 'false',
      required: false
    },
    customUrlPrefix: {
      type: String,
      default: '',
      required: false
    },
    autoRetry: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      fileList: [],
      uploading: false,
      maxUploading: 6,
      waitingList: [],
      exceptionList: [],
      listScrolled: false,
      fileListLength: 0,
      uploadCount: 0
    };
  },
  watch: {
    fileList: {
      handler() {
        if (this.fileList.length > this.fileListLength) {
          this.$nextTick(() => {
            setTimeout(() => {
              // this.$refs.scrollContainer.setScrollTop(this.$refs.scrollContainer.wrapRef.scrollHeight) // 滚动到底部
              this.$refs.scrollContainer.setScrollTop(0); // 滚动到顶部
            }, 100);
          });
        }
        this.fileListLength = this.fileList.length;
      },
      deep: true
    },
    useCustomUrl: {
      handler() {
        if (this.useCustomUrl === 'true') {
          this.fileList.forEach(item => {
            item.finalURL = this.customUrlPrefix + item.srcID;
            item.mdURL = `![${item.name}](${this.customUrlPrefix + item.srcID})`;
            item.htmlURL = `<img src="${this.customUrlPrefix + item.srcID}" alt="${item.name}" width=100% />`;
            item.ubbURL = `[img]${this.customUrlPrefix + item.srcID}[/img]`;
          });
        } else {
          const rootUrl = `${window.location.protocol}//${window.location.host}/file/`;
          this.fileList.forEach(item => {
            item.finalURL = rootUrl + item.srcID;
            item.mdURL = `![${item.name}](${rootUrl + item.srcID})`;
            item.htmlURL = `<img src="${rootUrl + item.srcID}" alt="${item.name}" width=100% />`;
            item.ubbURL = `[img]${rootUrl + item.srcID}[/img]`;
          });
        }
      },
      immediate: true
    },
    customUrlPrefix: {
      handler() {
        if (this.useCustomUrl === 'true') {
          this.fileList.forEach(item => {
            item.finalURL = this.customUrlPrefix + item.srcID;
            item.mdURL = `![${item.name}](${this.customUrlPrefix + item.srcID})`;
            item.htmlURL = `<img src="${this.customUrlPrefix + item.srcID}" alt="${item.name}" width=100% />`;
            item.ubbURL = `[img]${this.customUrlPrefix + item.srcID}[/img]`;
          });
        }
      },
      immediate: true
    }
  },
  computed: {
    uploadSuccessCount() {
      return this.fileList.filter(item => item.status === 'done' || item.status === 'success').length;
    },
    uploadErrorCount() {
      return this.fileList.filter(item => item.status === 'exception').length;
    },
    uploadingCount() {
      return this.fileList.filter(item => item.status === 'uploading').length;
    },
    waitingCount() {
      return this.waitingList.length;
    },
    urlSize() {
      // 移动端为small
      return window.innerWidth < 768 ? 'small' : 'default';
    },
    disableTooltip() {
      return window.innerWidth < 768;
    }
  },
  mounted() {
    document.addEventListener('paste', this.handlePaste);
  },
  beforeUnmount() {
    document.removeEventListener('paste', this.handlePaste);
  },
  methods: {
    uploadFile(file) {
      // 如果fileList中不存在该文件，说明已被删除，直接返回
      if (!this.fileList.find(item => item.uid === file.file.uid)) {
        return;
      }
      if (this.uploadingCount > this.maxUploading) {
        this.waitingList.push(file);
        this.fileList.find(item => item.uid === file.file.uid).status = 'waiting';
        return;
      } else {
        this.fileList.find(item => item.uid === file.file.uid).status = 'uploading';
      }
      const formData = new FormData();
      formData.append('file', file.file);
      // 判断是否需要服务端压缩
      const needServerCompress = this.fileList.find(item => item.uid === file.file.uid).serverCompress;
      axios({
        url: '/upload' + '?authCode=' + cookies.get('authCode') + '&serverCompress=' + needServerCompress + '&uploadChannel=' + this.uploadChannel + '&uploadNameType=' + this.uploadNameType + '&autoRetry=' + this.autoRetry,
        method: 'post',
        data: formData,
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round(progressEvent.loaded / progressEvent.total * 100);
          file.onProgress({
            percent: percentCompleted,
            file: file.file
          });
        }
      }).then(res => {
        file.onSuccess(res, file.file);
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          this.waitingList = [];
          this.fileList = [];
          this.$message.error('认证状态错误！');
          this.$router.push('/login');
        } else {
          this.exceptionList.push(file);
          file.onError(err, file.file);
        }
      }).finally(() => {
        if (this.uploadingCount + this.waitingCount === 0) {
          this.uploading = false;
        }
      });
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
      this.$message({
        type: 'info',
        message: file.name + '已删除'
      });
    },
    handleSuccess(response, file) {
      try {
        const rootUrl = this.useCustomUrl === 'true' ? this.customUrlPrefix : `${window.location.protocol}//${window.location.host}/file/`;
        // 从response.data[0].src中去除/file/前缀
        const srcID = response.data[0].src.replace('/file/', '');
        this.fileList.find(item => item.uid === file.uid).url = `${window.location.protocol}//${window.location.host}/file/` + srcID;
        this.fileList.find(item => item.uid === file.uid).finalURL = rootUrl + srcID;
        this.fileList.find(item => item.uid === file.uid).mdURL = `![${file.name}](${rootUrl + srcID})`;
        this.fileList.find(item => item.uid === file.uid).htmlURL = `<img src="${rootUrl + srcID}" alt="${file.name}" width=100% />`;
        this.fileList.find(item => item.uid === file.uid).ubbURL = `[img]${rootUrl + srcID}[/img]`;
        this.fileList.find(item => item.uid === file.uid).srcID = srcID;
        this.fileList.find(item => item.uid === file.uid).progreess = 100;
        this.fileList.find(item => item.uid === file.uid).status = 'success';
        this.$message({
          type: 'success',
          message: file.name + '上传成功'
        });
        setTimeout(() => {
          this.fileList.find(item => item.uid === file.uid).status = 'done';
        }, 1000);
      } catch (error) {
        this.$message.error(file.name + '上传失败');
        this.fileList.find(item => item.uid === file.uid).status = 'exception';
      } finally {
        if (this.uploadingCount + this.waitingCount === 0) {
          this.uploading = false;
        }
        if (this.waitingList.length) {
          const file = this.waitingList.shift();
          this.uploadFile(file);
        }
      }
    },
    handleError(err, file) {
      this.$message.error(file.name + '上传失败');
      this.fileList.find(item => item.uid === file.uid).status = 'exception';
      if (this.waitingList.length) {
        const file = this.waitingList.shift();
        this.uploadFile(file);
      }
      if (this.uploadingCount + this.waitingCount === 0) {
        this.uploading = false;
      }
    },
    handleCopy(file) {
      const status = this.fileList.find(item => item.uid === file.uid).status;
      if (status !== 'done' && status !== 'success') {
        this.$message({
          type: 'warning',
          message: '文件未上传成功，无法复制链接'
        });
        return;
      }
      if (this.selectedUrlForm === 'url') {
        navigator.clipboard.writeText(file.finalURL);
      } else if (this.selectedUrlForm === 'md') {
        navigator.clipboard.writeText(file.mdURL);
      } else if (this.selectedUrlForm === 'html') {
        navigator.clipboard.writeText(file.htmlURL);
      } else if (this.selectedUrlForm === 'ubb') {
        navigator.clipboard.writeText(file.ubbURL);
      } else {
        navigator.clipboard.writeText(file.finalURL);
      }
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        // 客户端压缩条件：1.文件类型为图片 2.开启客户端压缩，且文件大小大于压缩阈值；或为Telegram渠道且文件大小大于20MB
        const needCustomCompress = file.type.includes('image') && (this.customerCompress && file.size / 1024 / 1024 > this.compressBar || this.uploadChannel === 'telegram' && file.size / 1024 / 1024 > 20);
        const isLtLim = file.size / 1024 / 1024 < 20 || this.uploadChannel !== 'telegram';
        const pushFileToQueue = (file, serverCompress) => {
          const fileUrl = URL.createObjectURL(file);
          this.fileList.push({
            uid: file.uid,
            name: file.name,
            url: fileUrl,
            finalURL: '',
            mdURL: '',
            htmlURL: '',
            ubbURL: '',
            srcID: '',
            status: 'uploading',
            progreess: 0,
            serverCompress: serverCompress
          });
          resolve(file);
        };
        if (needCustomCompress) {
          //尝试压缩图片
          imageConversion.compressAccurately(file, 1024 * this.compressQuality).then(res => {
            //如果压缩后大于20MB，且上传渠道为telegram，则不上传
            if (res.size / 1024 / 1024 > 20 && this.uploadChannel === 'telegram') {
              this.$message.error(file.name + '压缩后文件过大，无法上传!');
              reject('文件过大');
            }
            this.uploading = true;
            //将res包装成新的file
            const newFile = new File([res], file.name, {
              type: res.type
            });
            newFile.uid = file.uid;
            const myUploadCount = this.uploadCount++;

            //开启服务端压缩条件：1.开启服务端压缩 2.文件大小小于10MB 3.上传渠道为Telegram
            const needServerCompress = this.serverCompress && newFile.size / 1024 / 1024 < 10 && this.uploadChannel === 'telegram';
            if (myUploadCount === 0) {
              pushFileToQueue(newFile, needServerCompress);
            } else {
              setTimeout(() => {
                pushFileToQueue(newFile, needServerCompress);
                this.uploadCount--;
              }, 300 * myUploadCount);
            }
          }).catch(err => {
            this.$message.error(file.name + '压缩失败，无法上传!');
            reject(err);
          });
        } else if (isLtLim) {
          this.uploading = true;
          const myUploadCount = this.uploadCount++;

          // 开启服务端压缩条件：1.上传渠道为Telegram 2.开启服务端压缩 3.如果为图片，则文件大小小于10MB，否则不限制大小
          const needServerCompress = this.uploadChannel === 'telegram' && this.serverCompress && (file.type.includes('image') ? file.size / 1024 / 1024 < 10 : true);
          if (myUploadCount === 0) {
            pushFileToQueue(file, needServerCompress);
          } else {
            setTimeout(() => {
              pushFileToQueue(file, needServerCompress);
              this.uploadCount--;
            }, 300 * myUploadCount);
          }
        } else {
          this.$message.error(file.name + '文件过大，无法上传!');
          reject('文件过大');
        }
      });
    },
    handleProgress(event) {
      this.fileList.find(item => item.uid === event.file.uid).progreess = event.percent;
    },
    copyAll() {
      if (this.selectedUrlForm === 'url') {
        const urls = this.fileList.map(item => {
          if (item.status === 'done' || item.status === 'success') {
            return item.finalURL;
          }
        }).join('\n');
        navigator.clipboard.writeText(urls);
      } else if (this.selectedUrlForm === 'md') {
        const urls = this.fileList.map(item => {
          if (item.status === 'done' || item.status === 'success') {
            return item.mdURL;
          }
        }).join('\n');
        navigator.clipboard.writeText(urls);
      } else if (this.selectedUrlForm === 'html') {
        const urls = this.fileList.map(item => {
          if (item.status === 'done' || item.status === 'success') {
            return item.htmlURL;
          }
        }).join('\n');
        navigator.clipboard.writeText(urls);
      } else if (this.selectedUrlForm === 'ubb') {
        const urls = this.fileList.map(item => {
          if (item.status === 'done' || item.status === 'success') {
            return item.ubbURL;
          }
        }).join('\n');
        navigator.clipboard.writeText(urls);
      } else {
        const urls = this.fileList.map(item => {
          if (item.status === 'done' || item.status === 'success') {
            return item.finalURL;
          }
        }).join('\n');
        navigator.clipboard.writeText(urls);
      }
      this.$message({
        type: 'success',
        message: '整体复制成功'
      });
    },
    clearFileList() {
      if (this.fileList.length > 0) {
        this.fileList = [];
        this.$message({
          type: 'success',
          message: '文件列表已清空'
        });
      } else {
        this.$message({
          type: 'info',
          message: '文件列表为空'
        });
      }
    },
    clearSuccessList() {
      if (this.uploadSuccessCount > 0) {
        this.fileList = this.fileList.filter(item => item.status !== 'done' && item.status !== 'success');
        this.$message({
          type: 'success',
          message: '成功上传文件已清空'
        });
      } else {
        this.$message({
          type: 'info',
          message: '成功上传文件为空'
        });
      }
    },
    handlePaste(event) {
      // 当粘贴位置是文本框时，不执行该操作
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          const file = items[i].getAsFile();
          // 判断文件类型是否为图片或视频
          if (file.type.includes('image') || file.type.includes('video')) {
            file.uid = Date.now() + i;
            file.file = file;
            //接收beforeUpload的Promise对象
            const checkResult = this.beforeUpload(file);
            if (checkResult instanceof Promise) {
              checkResult.then(newFile => {
                if (newFile instanceof File) {
                  this.uploadFile({
                    file: newFile,
                    onProgress: evt => this.handleProgress(evt),
                    onSuccess: (response, file) => this.handleSuccess(response, file),
                    onError: (error, file) => this.handleError(error, file)
                  });
                }
              }).catch(err => {
                console.log(err);
              });
            }
          } else {
            this.$message({
              type: 'warning',
              message: '粘贴板中的文件不是图片或视频'
            });
          }
        } else if (items[i].kind === 'string') {
          items[i].getAsString(text => {
            const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/;
            let fileName = '';
            if (urlPattern.test(text)) {
              fetch('/api/fetchRes', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  url: text
                })
              }).then(response => {
                const contentType = response.headers.get('content-type');
                if (response.status == 200 && (contentType.includes('image') || contentType.includes('video'))) {
                  // 提取文件名
                  const disposition = response.headers.get('Content-Disposition');
                  if (disposition) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const filenameStarRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/; // 处理 filename*

                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                      fileName = matches[1].replace(/['"]/g, '');
                      // 尝试解码
                      try {
                        fileName = decodeURIComponent(fileName);
                      } catch (e) {
                        fileName = '';
                      }
                    }
                    if (fileName === '') {
                      matches = filenameStarRegex.exec(disposition); // 尝试匹配 filename*
                      if (matches != null && matches[1]) {
                        fileName = decodeURIComponent(matches[1]);
                      }
                    }
                  }
                  // 尝试从URL中提取文件名
                  if (fileName === '') {
                    const url = new URL(text);
                    fileName = url.pathname.split('/').pop();
                  }
                  // 未提取到文件名，使用默认文件名
                  if (fileName === '') {
                    // 获取文件后缀
                    const url = new URL(text);
                    let extension = url.pathname.split('.').pop();
                    // 判断后缀是否有效
                    if (!['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'mp4', 'webm', 'ogg', 'mkv'].includes(extension)) {
                      extension = 'jpeg'; // 默认为jpeg
                    }
                    fileName = 'PastedFile' + Date.now() + i + '.' + extension;
                  }
                  return response.blob();
                } else {
                  throw new Error('URL地址的内容不是图片或视频');
                }
              }).then(blob => {
                const file = new File([blob], fileName, {
                  type: blob.type
                });
                file.uid = Date.now() + i;
                file.file = file;
                //接收beforeUpload的Promise对象
                const checkResult = this.beforeUpload(file);
                if (checkResult instanceof Promise) {
                  checkResult.then(newFile => {
                    if (newFile instanceof File) {
                      this.uploadFile({
                        file: newFile,
                        onProgress: evt => this.handleProgress(evt),
                        onSuccess: (response, file) => this.handleSuccess(response, file),
                        onError: (error, file) => this.handleError(error, file)
                      });
                    }
                  }).catch(err => {
                    console.log(err);
                  });
                }
              }).catch(error => {
                this.$message({
                  type: 'warning',
                  message: '粘贴板中的URL地址的内容不是图片或视频'
                });
              });
            }
          });
        }
      }
    },
    selectAllText(event) {
      // 复制到剪贴板
      navigator.clipboard.writeText(event.target.value).then(() => {
        this.$message({
          type: 'success',
          message: '复制成功'
        });
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '复制失败'
        });
      });
    },
    // 判断是否为图片类型
    isImage(fileName) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const extension = fileName.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    },
    // 判断是否为视频类型
    isVideo(fileName) {
      const videoExtensions = ['mp4', 'webm', 'ogg', 'mkv'];
      const extension = fileName.split('.').pop().toLowerCase();
      return videoExtensions.includes(extension);
    },
    handleScroll(event) {
      this.listScrolled = event.scrollTop > 0 && this.fileList.length > 0;
    },
    retryError() {
      if (this.exceptionList.length > 0) {
        this.exceptionList.forEach(file => {
          this.uploadFile({
            file: file.file,
            onProgress: evt => this.handleProgress(evt),
            onSuccess: (response, file) => this.handleSuccess(response, file),
            onError: (error, file) => this.handleError(error, file)
          });
        });
        this.exceptionList = [];
      } else {
        this.$message({
          type: 'info',
          message: '无上传失败文件'
        });
      }
    }
  }
};